import { createAxiosThunk } from 'utils/reduxUtil'
import { createSlice } from '@reduxjs/toolkit'
import { createTrackAndTrackRight } from 'api/axios/crux/bcon'

const initialState = {
  visibleCreate: false,
  name: '',
  trackId: null,
  isLoading: false,
  visibleInstall: false,
  tab: 'web',
}

export const createTrackRight = createAxiosThunk(
  'createTrack/createTrackRight',
  (noArgs, { getState }) => {
    const { name } = getState().tracker.createTrack
    const adAccountId = getState().account.current.id
    return createTrackAndTrackRight({ name, adAccountId })
  }
)

const createTrackSlice = createSlice({
  name: 'createTrack',
  initialState,

  reducers: {
    resetCreateTrack: () => initialState,
    showCreateTrackModal: state => {
      state.visibleCreate = true
    },
    hideCreateTrackModal: state => {
      state.visibleCreate = false
    },
    showInstallTrackModal: (state, { payload }) => {
      if (payload) {
        state.tab = payload
      }
      state.visibleInstall = true
    },
    hideInstallTrackModal: state => {
      state.visibleInstall = false
    },
    setName: (state, { payload }) => {
      state.name = payload
    },
    setTab: (state, { payload }) => {
      state.tab = payload
    },
  },

  extraReducers: builder => {
    builder.addCase(createTrackRight.pending, state => {
      state.trackId = null
      state.isLoading = true
    })

    builder.addCase(
      createTrackRight.fulfilled,
      (state, { payload: { body } }) => {
        const { trackId } = body
        state.trackId = trackId
        state.isLoading = false
      }
    )

    builder.addCase(createTrackRight.rejected, state => {
      state.isLoading = false
    })
  },
})

export const {
  showCreateTrackModal,
  hideCreateTrackModal,
  showInstallTrackModal,
  hideInstallTrackModal,
  setName,
  setTab,
  resetCreateTrack,
} = createTrackSlice.actions
export default createTrackSlice.reducer
